module.exports = __webpack_public_path__ + "static/img/caseImg8.39eeaad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/caseImg8.jpg
// module id = nKpw
// module chunks = 0